/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UpdateDpsStatus$Params {
      body: {
'status': 'IN_REVIEW' | 'NOT_SCREENED';
}
}

export function updateDpsStatus(http: HttpClient, rootUrl: string, params: UpdateDpsStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'statusCode'?: number;
'body'?: {
'message': string;
'messageKey': string;
};
}>> {
  const rb = new RequestBuilder(rootUrl, updateDpsStatus.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'statusCode'?: number;
      'body'?: {
      'message': string;
      'messageKey': string;
      };
      }>;
    })
  );
}

updateDpsStatus.PATH = '/api/v1/session/dps-status';
